import React, { useEffect, useState } from "react";
import { Button, DatePicker, Input, Switch } from "antd";
import { ErrorToast, SuccessToast } from "../../../../widgets/AppToast";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import useUserData from "../../../../hooks/useUserData";
import moment from "moment";
import { currentUnits, pressureUnits } from "../../../../Data/data";
import UnitWithInput from "../../../../components/UnitWithInput";
import dayjs from "dayjs";
import { useDate } from "../../../../context/DateContext";

function AuxiliaryPump({ eng_log_basic_id, _items }) {
  const user = useUserData();
  const { selectedDate } = useDate();
  const [loader, set_loader] = useState(false);
  const [errors, set_errors] = useState({});
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [suc, set_Suc] = useState("");
  const [disch, set_Disch] = useState("");
  const [checked, setChecked] = useState(false);
  const [update_status, set_update_status] = useState(false);
  const [auxi_pump_id, set_auxi_pump_id] = useState("");
  const [submitStatus, setSubmitStatus] = useState(false);
  const [logDate, set_LogDate] = useState(null);
  const [pump_Suction_Pressure_Unit, set_Pump_Suction_Pressure_Unit] =
    useState("");
  const [pump_Discharge_Pressure_Unit, set_Pump_Discharge_Pressure_Unit] =
    useState("");
  const [current_unit, set_current_unit] = useState("");
  const [otherParams, setOtherParams] = useState({});
  const [current, set_Current] = useState("");

  // Map parameter names to labels and units
  const parameterConfig = {
    suctionPressure: { label: "Suction Pressure", unitList: pressureUnits },
    dischargePressure: { label: "Discharge Pressure", unitList: pressureUnits },
    current: { label: "Current", unitList: currentUnits },
  };

  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staff_dashboards);
    set_staff_dashboard(parsedData);
    if (parsedData && _items) {
      VIEW_AUXILARY_PUMP_DETAILS_LOGBOOK_API(_items?.id, parsedData);
      // Safely initialize other parameters
      const otherParamsData = Array.isArray(_items?.other_parameters)
        ? _items.other_parameters
        : [];
      const initialOtherParams = otherParamsData.reduce((acc, param) => {
        acc[param.name] = { value: "", unit: param.unit || "" };
        return acc;
      }, {});
      setOtherParams(initialOtherParams);
    }
  }, [_items?.id]);

  const onChangeDateTime = (value) => {
    if (value) {
      set_LogDate(value.format("YYYY-MM-DD HH:mm:ss"));
    } else {
      set_LogDate(null);
    }
  };

  const handleOtherParamChange = (name, field, value) => {
    setOtherParams((prev) => ({
      ...prev,
      [name]: { ...prev[name], [field]: value },
    }));
  };

  const ADD_AUXILARY_PUMP_DETAILS_LOGBOOK_API = async (pump_id, pump_on) => {
    set_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append(
        "date_time_log",
        logDate || moment().format("YYYY-MM-DD HH:mm:ss")
      );
      FORM_DATA.append("eng_log_basic_id", Number(eng_log_basic_id) || 0);
      FORM_DATA.append(
        "voyage_id",
        Number(staff_dashboard?.voyage_details?.[0]?.id) || 0
      );
      FORM_DATA.append("suction_pressure", Number(suc) || 0);
      FORM_DATA.append("discharge_pressure", Number(disch) || 0);
      FORM_DATA.append("current", Number(current) || 0);
      FORM_DATA.append("pump_id", Number(pump_id) || 0);
      FORM_DATA.append("pump_on_off", pump_on);
      FORM_DATA.append(
        "suction_pressure_unit",
        pump_Suction_Pressure_Unit || ""
      );
      FORM_DATA.append(
        "discharge_pressure_unit",
        pump_Discharge_Pressure_Unit || ""
      );
      FORM_DATA.append("current_unit", current_unit || "");
      FORM_DATA.append("other_parameters", JSON.stringify(otherParams));
      // Append other parameters
      Object.entries(otherParams).forEach(([name, { value, unit }]) => {
        FORM_DATA.append(`other_${name}`, value);
        FORM_DATA.append(`other_${name}_unit`, unit);
      });

      post(ApiURL.add_auxiliary_pump_info_st, FORM_DATA).then((res) => {
        if (res?.status === true) {
          SuccessToast(
            "Logbook Add Success!",
            "Logbook Auxilary Pump details have been successfully Add!"
          );
          set_loader(false);
          if (staff_dashboard)
            VIEW_AUXILARY_PUMP_DETAILS_LOGBOOK_API(
              res?.pump_data?.pump_id,
              staff_dashboard
            );
        } else {
          ErrorToast("ERROR Message!", res?.message);
          set_errors(res?.errors || {});
        }
      });
    } catch (error) {
      console.error("Error Adding logbook:", error);
    } finally {
      set_loader(false);
    }
  };

  const UPDATE_AUXILARY_PUMP_DETAILS_LOGBOOK_API = async (
    pump_id,
    auxi_pump_id,
    save_submit,
    pump_on
  ) => {
    set_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append(
        "date_time_log",
        logDate || moment().format("YYYY-MM-DD HH:mm:ss")
      );
      FORM_DATA.append("save_submit", Number(save_submit) || 0);
      FORM_DATA.append("eng_log_basic_id", Number(eng_log_basic_id) || 0);
      FORM_DATA.append(
        "voyage_id",
        Number(staff_dashboard?.voyage_details?.[0]?.id) || 0
      );
      FORM_DATA.append("suction_pressure", Number(suc) || 0);
      FORM_DATA.append("discharge_pressure", Number(disch) || 0);
      FORM_DATA.append("current", Number(disch) || 0);
      FORM_DATA.append("pump_id", Number(pump_id) || 0);
      FORM_DATA.append("auxi_pump_id", Number(auxi_pump_id) || 0);
      FORM_DATA.append("pump_on_off", pump_on);
      FORM_DATA.append(
        "suction_pressure_unit",
        pump_Suction_Pressure_Unit || ""
      );
      FORM_DATA.append(
        "discharge_pressure_unit",
        pump_Discharge_Pressure_Unit || ""
      );
      FORM_DATA.append("current_unit", current_unit || "");
      FORM_DATA.append("other_parameters", JSON.stringify(otherParams));

      // Append other parameters
      Object.entries(otherParams).forEach(([name, { value, unit }]) => {
        FORM_DATA.append(`other_${name}`, value);
        FORM_DATA.append(`other_${name}_unit`, unit);
      });

      post(ApiURL.view_update_auxiliary_pump_st, FORM_DATA).then((res) => {
        if (res?.status === true) {
          SuccessToast(
            "Logbook Update Success!",
            "Logbook Auxilary Pump details have been successfully Update!"
          );
          set_loader(false);
          if (staff_dashboard)
            VIEW_AUXILARY_PUMP_DETAILS_LOGBOOK_API(
              res?.pump_data?.pump_id,
              staff_dashboard
            );
        } else {
          ErrorToast("Error message", "Submission failed! Please try again.");
          set_errors(res?.errors || {});
        }
      });
    } catch (error) {
      console.error("Error Updating logbook:", error);
    } finally {
      set_loader(false);
    }
  };

  const VIEW_AUXILARY_PUMP_DETAILS_LOGBOOK_API = async (pump_id, voyage_id) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("pump_id", pump_id);
      FORM_DATA.append("eng_log_basic_id", eng_log_basic_id);
      FORM_DATA.append("voyage_id", voyage_id?.voyage_details?.[0]?.id);
      post(ApiURL.view_update_auxiliary_pump_st, FORM_DATA).then((res) => {
        const pump_Data = res?.pump_data;

        if (res?.status === true) {
          set_update_status(pump_Data?.complete_status);
          set_auxi_pump_id(pump_Data?.auxi_pump_id);
          set_Suc(pump_Data?.suction_pressure || "");
          set_Disch(pump_Data?.discharge_pressure || "");
          set_Current(pump_Data?.current || "");
          set_current_unit(pump_Data?.current_unit);

          setChecked(pump_Data?.pump_on_off || false);

          setSubmitStatus(res?.submit_status || false);
          set_LogDate(
            pump_Data?.date_time_log || moment().format("YYYY-MM-DD HH:mm:ss")
          );
          set_Pump_Suction_Pressure_Unit(
            pump_Data?.suction_pressure_unit || ""
          );
          set_Pump_Discharge_Pressure_Unit(
            pump_Data?.discharge_pressure_unit || ""
          );
          set_current_unit(pump_Data?.motor_current_unit || "");

          const rawItemParams = _items?.other_parameters;
          const itemParams = Array.isArray(rawItemParams) ? rawItemParams : [];
          const pumpParams = pump_Data?.other_parameters || {};

          // Merge the two datasets
          const mergedParams = itemParams?.map((param) => {
            const paramName = param.name;
            const pumpEntry = pumpParams[paramName] || {};
            return {
              name: paramName,
              unit: param.unit || pumpEntry.unit || "",
              value: pumpEntry.value || "",
            };
          });

          const otherParamsData = Array.isArray(mergedParams)
            ? mergedParams
            : [];
          const initialOtherParams = otherParamsData.reduce((acc, param) => {
            acc[param.name] = {
              value: param.value || "",
              unit: param.unit || "",
            };
            return acc;
          }, {});

          setOtherParams(initialOtherParams);
        } else {
          set_errors(res?.errors || {});
        }
      });
    } catch (error) {
      console.error("Error updating logbook:", error);
    }
  };

  const otherParameterUnits = [
    ...new Set(Object.values(otherParams || {}).map((param) => param.unit)),
  ];

  return (
    <>
      <div className="row custom-box">
        <div className="col-4">
          <b style={{ color: "#161515", fontSize: "15px" }}>
            Pump Make:- {_items?.pump_maker}
          </b>
        </div>
        <div className="col-4">
          <b style={{ color: "#161515", fontSize: "15px" }}>
            Pump Model:- {_items?.pump_model}
          </b>
        </div>
        <div className="col-4">
          <b style={{ color: "#161515", fontSize: "15px" }}>
            Pump title:- {_items?.title}
          </b>
        </div>
        <div className="col-4">
          <b style={{ color: "#161515", fontSize: "15px" }}>
            Pump Id:- {_items?.id}
          </b>
        </div>
        <div className="col-2">
          <Switch
            disabled={submitStatus}
            checked={checked}
            onChange={(value) => {
              setChecked(value);
              if (value || !value) {
                update_status
                  ? UPDATE_AUXILARY_PUMP_DETAILS_LOGBOOK_API(
                      _items?.id,
                      auxi_pump_id,
                      "0",
                      value
                    )
                  : ADD_AUXILARY_PUMP_DETAILS_LOGBOOK_API(_items?.id, value);
              }
            }}
            checkedChildren="On"
            unCheckedChildren="Off"
            style={{ backgroundColor: checked ? "green" : "red" }}
          />
        </div>
      </div>

      {checked && (
        <>
          {(() => {
            const selectedParams = _items.selected_parameters || [];
            const rows = [];
            let i = 0;

            // Handle first row separately (Date + 2 params)
            const firstRowParams = selectedParams.slice(0, 2);
            rows.push(
              <div className="row" key="row-0">
                {/* Date picker column */}
                <div className="col-4">
                  <div className="input-box">
                    <label>Date & Time</label>
                    <DatePicker
                      disabled
                      showTime
                      format="YYYY-MM-DD HH:mm:ss"
                      placeholder="Select Date & Time"
                      // value={logDate ? dayjs(logDate, "YYYY-MM-DD HH:mm:ss") : null}
                      value={
                        update_status && logDate
                          ? dayjs(logDate, "YYYY-MM-DD HH:mm:ss")
                          : selectedDate
                          ? dayjs(selectedDate, "YYYY-MM-DD HH:mm:ss")
                          : null
                      }
                      onChange={onChangeDateTime}
                      style={{ width: "100%" }}
                      // disabled={submitStatus}
                    />
                    {errors.date_time_log && (
                      <p className="error-text">{errors.date_time_log}</p>
                    )}
                  </div>
                </div>

                {firstRowParams?.map((param) => {
                  const config = parameterConfig[param];
                  if (!config) return null;

                  const stateMap = {
                    suctionPressure: [suc, set_Suc],
                    dischargePressure: [disch, set_Disch],
                    current: [current, set_Current],
                  };
                  const [value, setValue] = stateMap[param] || [];
                  const unitStateMap = {
                    suctionPressure: [
                      pump_Suction_Pressure_Unit,
                      set_Pump_Suction_Pressure_Unit,
                    ],
                    dischargePressure: [
                      pump_Discharge_Pressure_Unit,
                      set_Pump_Discharge_Pressure_Unit,
                    ],
                    current: [current_unit, set_current_unit],
                  };
                  const [unit, setUnit] = unitStateMap[param] || [];
                  const errorKey = `pump_${param.replace(
                    /([A-Z])/g,
                    (match) => `_${match.toLowerCase()}`
                  )}`;

                  return (
                    <div className="col-4" key={param}>
                      {config.unitList.length ? (
                        <UnitWithInput
                          label={config.label}
                          value={value}
                          onChange={(e) => setValue(e.target.value)}
                          unit={unit}
                          onUnitChange={(e) => setUnit(e.target.value)}
                          disabled={submitStatus}
                          error={errors[errorKey]}
                          unitList={config.unitList}
                        />
                      ) : (
                        <div className="input-box">
                          <label>{config.label}</label>
                          <Input
                            disabled={submitStatus}
                            value={value}
                            placeholder={config.label}
                            onChange={(e) => setValue(e.target.value)}
                          />
                          {errors?.[errorKey] && (
                            <span style={{ color: "red" }}>
                              {errors[errorKey]}
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            );

            // Remaining rows (start from index 2)
            for (i = 2; i < selectedParams.length; i += 3) {
              const group = selectedParams.slice(i, i + 3);
              rows.push(
                <div className="row" key={`row-${i}`}>
                  {group.map((param) => {
                    const config = parameterConfig[param];
                    if (!config) return null;

                    const stateMap = {
                      suctionPressure: [suc, set_Suc],
                      dischargePressure: [disch, set_Disch],
                      current: [current, set_Current],
                    };
                    const [value, setValue] = stateMap[param] || [];
                    const unitStateMap = {
                      suctionPressure: [
                        pump_Suction_Pressure_Unit,
                        set_Pump_Suction_Pressure_Unit,
                      ],
                      dischargePressure: [
                        pump_Discharge_Pressure_Unit,
                        set_Pump_Discharge_Pressure_Unit,
                      ],
                      current: [current_unit, set_current_unit],
                    };
                    const [unit, setUnit] = unitStateMap[param] || [];
                    const errorKey = `pump_${param.replace(
                      /([A-Z])/g,
                      (match) => `_${match.toLowerCase()}`
                    )}`;

                    return (
                      <div className="col-4" key={param}>
                        {config.unitList.length ? (
                          <UnitWithInput
                            label={config.label}
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                            unit={unit}
                            onUnitChange={(e) => setUnit(e.target.value)}
                            disabled={submitStatus}
                            error={errors[errorKey]}
                            unitList={config.unitList}
                          />
                        ) : (
                          <div className="input-box">
                            <label>{config.label}</label>
                            <Input
                              disabled={submitStatus}
                              value={value}
                              placeholder={config.label}
                              onChange={(e) => setValue(e.target.value)}
                            />
                            {errors?.[errorKey] && (
                              <span style={{ color: "red" }}>
                                {errors[errorKey]}
                              </span>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              );
            }

            return rows;
          })()}

          <div className="row">
            {typeof otherParams === "object" && otherParams !== null
              ? Object.entries(otherParams).map(([name, { value, unit }]) => (
                  <div className="col-4" key={name}>
                    <UnitWithInput
                      label={name}
                      value={value}
                      onChange={(e) =>
                        handleOtherParamChange(name, "value", e.target.value)
                      }
                      unit={unit}
                      onUnitChange={(e) =>
                        handleOtherParamChange(name, "unit", e.target.value)
                      }
                      disabled={submitStatus}
                      unitList={otherParameterUnits}
                    />
                  </div>
                ))
              : null}
          </div>

          <div
            className="row"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "15px",
              marginLeft: "5px",
            }}
          >
            {["Chief Engineer"].includes(user?.data?.designation) &&
              eng_log_basic_id && (
                <Button
                  disabled={submitStatus}
                  loading={loader}
                  className="save_btn"
                  style={{ color: "white" }}
                  onClick={() =>
                    update_status
                      ? UPDATE_AUXILARY_PUMP_DETAILS_LOGBOOK_API(
                          _items?.id,
                          auxi_pump_id,
                          "1",
                          checked
                        )
                      : ADD_AUXILARY_PUMP_DETAILS_LOGBOOK_API(
                          _items?.id,
                          checked
                        )
                  }
                >
                  Submit
                </Button>
              )}
            <Button
              disabled={submitStatus}
              loading={loader}
              className="save_btn"
              style={{ color: "white" }}
              onClick={() =>
                update_status
                  ? UPDATE_AUXILARY_PUMP_DETAILS_LOGBOOK_API(
                      _items?.id,
                      auxi_pump_id,
                      "0",
                      checked
                    )
                  : ADD_AUXILARY_PUMP_DETAILS_LOGBOOK_API(_items?.id, checked)
              }
            >
              Save
            </Button>
          </div>
        </>
      )}
    </>
  );
}

export default AuxiliaryPump;
